import { Controller } from "@hotwired/stimulus"
import { ehaz_unlink_path } from "../routes"

export default class extends Controller {
  static values = { 
    confirmMessage: String 
  }

  unlink(event) {
    event.preventDefault()
    
    if (confirm(this.confirmMessageValue)) {
      this.performUnlink()
    }
  }

  async performUnlink() {
    try {
      const url = ehaz_unlink_path()
      console.log('Unlink URL:', url)
      
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
        }
      })

      if (response.ok) {
        // Reload the page to show updated menu
        window.location.reload()
      } else {
        const errorData = await response.json()
        alert(errorData.error || 'An error occurred during unlinking')
      }
    } catch (error) {
      console.error('Unlink error:', error)
      alert('An error occurred during unlinking')
    }
  }
}
